import React from "react";

const About = () => {
  return (
    <div className="py-6 px-3">
      <div>
        <h3 className="text-2xl text-white font-500 italic">
          PROSPER KUCOZWA SUCCESS
        </h3>
        <p className="py-2 text-slate-300 px-2">
          From Nigeria. Frontend development is my niche of operation where I
          direct a plethora of my workings such as, user-facing features,
          determining the structure and design of web pages, building reusable
          codes and optimizing page.
          <p className="py-2 text-slate-300 px-2 ident-10">
            I speak JavaScript, HTML and CSS alongside their corresponding
            libraries with a great proficiency.
          </p>
        </p>

        <h3 className="text-white text-[1.3rem] italic font-500">Experience</h3>
        <p className="py-2 text-slate-300 px-2 ident-10">
          It's been 3 years journey of bugs and fixes😅
        </p>
      </div>
    </div>
  );
};

export default About;
